import { useState } from "react";
import { Modal } from "react-bootstrap";
import ModalComponentN4 from "../../components/Modal/ModalComponentN4";

export default function TableN4IGV({ data }) {
    const [show, setShow] = useState(false);
    const [dataModal, setDataModal] = useState("");

    return (
        <div>
            <div className="table-responsive">
                <table className="table caption-top table-striped table-bordered">
                    <caption>Primer Marker Publication</caption>
                    <thead>
                        <tr>
                            <th scope="col" className="font-monospace">
                                Marker Name
                            </th>
                            <th scope="col" className="font-monospace">
                                Trait Category
                            </th>
                            <th scope="col" className="font-monospace">
                                Chromosome
                            </th>
                            <th scope="col" className="font-monospace">
                                Position
                            </th>
                            <th scope="col" className="font-monospace">
                                Favourable Allele
                            </th>
                            <th scope="col" className="font-monospace">
                                Unfavourable Allele{" "}
                            </th>
                            <th scope="col" className="font-monospace">
                                Target QTL
                            </th>
                            <th scope="col" className="text-center">
                                {/* การดำเนินการ */}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 &&
                            data.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th scope="row" className="font-monospace">
                                            {item?.marker_name}
                                        </th>
                                        <td className="font-monospace">{item?.trait_category}</td>
                                        <td className="font-monospace">{item?.chromosome}</td>
                                        <td className="font-monospace">{item?.position}</td>
                                        <td className="font-monospace">{item?.favourable_allele}</td>
                                        <td className="font-monospace">{item?.unfavourable_allele}</td>
                                        <td className="font-monospace">{item?.target_qtl}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => {
                                                    setShow(true);
                                                    setDataModal(item);
                                                }}
                                            >
                                                อ่านเพิ่มเติม
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>

            <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Primer Marker Publication</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalComponentN4 data={dataModal} />
                </Modal.Body>
            </Modal>
        </div>
    );
}
